(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["terms-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.ShopifyTermsConsent && typeof window.ShopifyTermsConsent.refresh === 'function') {
      window.ShopifyTermsConsent.refresh();
      return;
    }

    const STORAGE_KEY = 'shopify.terms_consent.accepted';
    const components = new Set();
    const componentState = new WeakMap();
    const formModes = new Map();
    let pendingAction = null;
    let observer = null;

    function readStored() {
      try {
        return localStorage.getItem(STORAGE_KEY) === 'true';
      } catch (error) {
        console.warn('Terms consent storage unavailable', error);
        return false;
      }
    }

    function writeStored(value) {
      try {
        localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
      } catch (error) {
        console.warn('Terms consent storage unavailable', error);
      }
    }

    const state = { accepted: false };

    function getComponentState(component) {
      let meta = componentState.get(component);
      if (!meta) {
        meta = { processing: false, promise: null };
        componentState.set(component, meta);
      }
      return meta;
    }

    function escapeSelector(value) {
      if (!value) return value;
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value);
      }
      return value.replace(/([^a-zA-Z0-9_-])/g, '\\$1');
    }

    function getTargetsForForm(formId) {
      if (!formId) return [];
      const nodes = document.querySelectorAll('[data-terms-consent-target]');
      return Array.prototype.filter.call(nodes, (node) => {
        const attrForm = node.getAttribute('form');
        if (attrForm) {
          return attrForm === formId;
        }
        const form = node.closest('form');
        return form && form.id === formId;
      });
    }

    function getExpressContainers(formId) {
      if (!formId) return [];
      const selector = '[data-terms-consent-express][data-form-id="' + escapeSelector(formId) + '"]';
      return Array.prototype.slice.call(document.querySelectorAll(selector));
    }

    function toggleButtons(formId, accepted) {
      if (!formId) return;
      const mode = formModes.get(formId) || 'checkbox';
      getTargetsForForm(formId).forEach((button) => {
        if (!button.dataset.termsConsentPrevDisabled) {
          button.dataset.termsConsentPrevDisabled = button.disabled ? 'true' : 'false';
        }

        if (mode === 'modal') {
          button.disabled = button.dataset.termsConsentPrevDisabled === 'true';
          button.classList.remove('terms-consent__button-locked');
          return;
        }

        if (accepted) {
          if (button.dataset.termsConsentPrevDisabled === 'false') {
            button.disabled = false;
          }
          button.classList.remove('terms-consent__button-locked');
        } else {
          button.disabled = true;
          button.classList.add('terms-consent__button-locked');
        }
      });
    }

    function toggleExpress(formId, accepted) {
      if (!formId) return;
      const mode = formModes.get(formId) || 'checkbox';
      getExpressContainers(formId).forEach((container) => {
        if (typeof container.dataset.termsConsentExpressOriginalDisplay === 'undefined') {
          container.dataset.termsConsentExpressOriginalDisplay = container.style.display || '';
        }

        if (mode === 'modal') {
          container.style.display = container.dataset.termsConsentExpressOriginalDisplay;
          container.removeAttribute('aria-disabled');
          container.removeAttribute('hidden');
          return;
        }

        if (accepted) {
          container.style.display = container.dataset.termsConsentExpressOriginalDisplay;
          container.removeAttribute('aria-disabled');
          container.removeAttribute('hidden');
        } else {
          container.style.display = 'none';
          container.setAttribute('aria-disabled', 'true');
          container.setAttribute('hidden', 'hidden');
        }
      });
    }

    function applyState(component, accepted, options) {
      const checkbox = component.querySelector('[data-terms-consent-checkbox]');
      const hiddenInput = component.querySelector('[data-terms-consent-input]');
      const errorEl = component.querySelector('[data-terms-consent-error]');
      const formId = component.dataset.formId;
      const mode = formModes.get(formId) || component.dataset.termsConsentMode || 'checkbox';

      if (checkbox) {
        checkbox.checked = accepted;
      }
      if (hiddenInput) {
        hiddenInput.value = accepted ? 'accepted' : '';
      }
      if (errorEl && (!options || options.hideError)) {
        errorEl.hidden = true;
      }

      toggleButtons(formId, accepted);
      toggleExpress(formId, accepted);

      if (mode === 'modal' && !accepted) {
        const errorSummary = component.querySelector('[data-terms-consent-error]');
        if (errorSummary) {
          errorSummary.hidden = true;
        }
      }
    }

    function showError(component, message) {
      const errorEl = component.querySelector('[data-terms-consent-error]');
      if (!errorEl) return;
      if (message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
        errorEl.setAttribute('aria-live', 'assertive');
      } else {
        errorEl.hidden = true;
      }
    }

    function clearError(component) {
      showError(component, '');
    }

    function showStatus(component, message) {
      const statusEl = component.querySelector('[data-terms-consent-status]');
      if (!statusEl) return;
      if (message) {
        statusEl.textContent = message;
        statusEl.hidden = false;
      } else {
        statusEl.textContent = '';
        statusEl.hidden = true;
      }
    }

    function setBusy(component, busy) {
      if (!component) return;
      if (busy) {
        component.setAttribute('data-terms-consent-busy', 'true');
      } else {
        component.removeAttribute('data-terms-consent-busy');
      }
      const checkbox = component.querySelector('[data-terms-consent-checkbox]');
      const acceptButton = component.querySelector('[data-terms-consent-accept]');
      if (checkbox) {
        checkbox.disabled = busy;
      }
      if (acceptButton) {
        acceptButton.disabled = busy;
      }
    }

    function getHashSource(component) {
      if (!component) return '';
      const modalBody = component.querySelector('.terms-consent__modal-body');
      if (modalBody) {
        return modalBody.textContent || modalBody.innerText || modalBody.innerHTML || '';
      }
      const label = component.querySelector('.terms-consent__label');
      if (label) {
        return label.textContent || label.innerText || label.innerHTML || '';
      }
      return '';
    }

    function determinePath(component, override) {
      if (override) {
        return override;
      }
      if (pendingAction && pendingAction.type === 'express') {
        return 'dynamic_checkout';
      }
      return 'cart';
    }

    function handleAcceptance(component, options) {
      const { path, onSuccess, onFailure } = options || {};
      const meta = getComponentState(component);
      if (meta.processing && meta.promise) {
        return meta.promise;
      }

      const version = component.dataset.termsConsentVersion || 'v1.0';
      const hashSource = getHashSource(component);
      const recordingText = component.dataset.termsConsentRecordingText;
      const recordingErrorText = component.dataset.termsConsentRecordingErrorText || component.dataset.errorText || '';

      const promise = (async () => {
        const audit = window.TermsConsentAudit;
        if (!audit || typeof audit.record !== 'function') {
          throw new Error('TermsConsentAudit unavailable');
        }

        clearError(component);
        if (recordingText) {
          showStatus(component, recordingText);
        } else {
          showStatus(component, '');
        }
        setBusy(component, true);

        try {
          const result = await audit.record({
            version,
            path: path || determinePath(component),
            hashSource,
          });
          state.accepted = true;
          writeStored(true);
          components.forEach((entry) => applyState(entry, true, { hideError: true }));
          showStatus(component, '');
          clearError(component);
          if (typeof onSuccess === 'function') {
            onSuccess(result);
          }
          return result;
        } catch (error) {
          state.accepted = false;
          writeStored(false);
          components.forEach((entry) => applyState(entry, false, { hideError: true }));
          if (recordingErrorText) {
            showError(component, recordingErrorText);
          }
          if (typeof onFailure === 'function') {
            onFailure(error);
          }
          throw error;
        } finally {
          showStatus(component, '');
          setBusy(component, false);
        }
      })();

      meta.processing = true;
      meta.promise = promise.finally(() => {
        meta.processing = false;
        meta.promise = null;
      });

      return promise;
    }

    function revealError(component) {
      const message = component.dataset.errorText || '';
      if (message) {
        showError(component, message);
      } else {
        showError(component, '');
      }

      const checkbox = component.querySelector('[data-terms-consent-checkbox]');
      if (checkbox && !checkbox.checked) {
        try {
          checkbox.focus({ preventScroll: false });
        } catch (error) {
          checkbox.focus();
        }
      }
    }

    function openModal(component) {
      const modal = component.querySelector('[data-terms-consent-modal]');
      if (!modal) return;
      modal.hidden = false;
      modal.dataset.active = 'true';
      document.body?.classList.add('terms-consent-modal-open');

      const focusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (typeof trapFocus === 'function') {
        trapFocus(modal, focusable || modal);
      } else if (focusable) {
        try {
          focusable.focus({ preventScroll: false });
        } catch (error) {
          focusable.focus();
        }
      }
    }

    function closeModal(component, options) {
      const opts = options || {};
      const modal = component.querySelector('[data-terms-consent-modal]');
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      modal.dataset.active = '';
      document.body?.classList.remove('terms-consent-modal-open');

      const trigger = component.querySelector('[data-terms-consent-trigger]');
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(trigger || null);
      } else if (trigger) {
        try {
          trigger.focus({ preventScroll: false });
        } catch (error) {
          trigger.focus();
        }
      }

      if (!opts.preservePending && pendingAction && pendingAction.component === component) {
        pendingAction = null;
      }
    }

    function resolvePendingAction() {
      if (!pendingAction) return;
      const action = pendingAction;
      pendingAction = null;

      if (action.type === 'express') {
        const target =
          action.trigger ||
          (action.container && action.container.querySelector('button, [role="button"], [type="submit"]'));
        if (target && typeof target.click === 'function') {
          setTimeout(() => target.click(), 0);
        }
      }
    }

    function setupExpressIntercept(component) {
      if (!component) return;
      const formId = component.dataset.formId;
      const mode = component.dataset.termsConsentMode || 'checkbox';
      if (!formId || mode !== 'modal') return;

      getExpressContainers(formId).forEach((container) => {
        if (container.dataset.termsConsentIntercept === 'true') return;
        container.dataset.termsConsentIntercept = 'true';
        container.addEventListener(
          'click',
          (event) => {
            if (state.accepted) return;
            const trigger = event.target && event.target.closest('button, [role="button"], [type="submit"]');
            pendingAction = { type: 'express', container, trigger, component };
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
              event.stopImmediatePropagation();
            }
            openModal(component);
          },
          true
        );
      });
    }

    function initComponent(component) {
      if (!component || components.has(component)) return;
      components.add(component);

      const checkbox = component.querySelector('[data-terms-consent-checkbox]');
      const trigger = component.querySelector('[data-terms-consent-trigger]');
      const closers = component.querySelectorAll('[data-terms-consent-close], .terms-consent__modal-backdrop');
      const acceptButton = component.querySelector('[data-terms-consent-accept]');
      const formId = component.dataset.formId;
      const form = formId ? document.getElementById(formId) : null;
      const mode = component.dataset.termsConsentMode || 'checkbox';

      if (formId) {
        formModes.set(formId, mode);
      }

      applyState(component, state.accepted, { hideError: true });
      clearError(component);
      showStatus(component, '');
      setBusy(component, false);

      checkbox?.addEventListener('change', () => {
        if (!checkbox.checked) {
          state.accepted = false;
          writeStored(false);
          components.forEach((entry) => {
            applyState(entry, false, { hideError: true });
          });
          clearError(component);
          showStatus(component, '');
          return;
        }

        handleAcceptance(component, {
          path: 'cart',
          onFailure: () => {
            checkbox.checked = false;
          },
        }).catch(() => {});
      });

      if (form && checkbox) {
        form.addEventListener(
          'submit',
          (event) => {
            if (!checkbox || checkbox.checked) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            revealError(component);
          },
          true
        );
      }

      trigger?.addEventListener('click', () => openModal(component));
      closers.forEach((closeEl) => {
        closeEl.addEventListener('click', () => closeModal(component));
      });

      acceptButton?.addEventListener('click', () => {
        if (state.accepted) {
          closeModal(component, { preservePending: true });
          resolvePendingAction();
          return;
        }

        handleAcceptance(component, {
          path: determinePath(component),
          onSuccess: () => {
            closeModal(component, { preservePending: true });
            resolvePendingAction();
          },
        }).catch(() => {});
      });

      component.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeModal(component);
        }
      });

      if (mode === 'modal') {
        setupExpressIntercept(component);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-terms-consent]').forEach(initComponent);
    }

    function handleMutations(mutations) {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches('[data-terms-consent]')) {
            initComponent(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('[data-terms-consent]').forEach(initComponent);
          }

          if (
            node.matches('[data-terms-consent-target]') ||
            (node.querySelectorAll && node.querySelector('[data-terms-consent-target]'))
          ) {
            components.forEach((component) => {
              toggleButtons(component.dataset.formId, state.accepted);
            });
          }

          if (
            node.matches('[data-terms-consent-express]') ||
            (node.querySelectorAll && node.querySelector('[data-terms-consent-express]'))
          ) {
            components.forEach((component) => {
              toggleExpress(component.dataset.formId, state.accepted);
              if ((component.dataset.termsConsentMode || 'checkbox') === 'modal') {
                setupExpressIntercept(component);
              }
            });
          }
        });
      });
    }

    function startObserver() {
      if (!document.body || observer) return;
      observer = new MutationObserver(handleMutations);
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initAll();
        startObserver();
      });
    } else {
      initAll();
      startObserver();
    }

    window.ShopifyTermsConsent = {
      refresh: initAll,
      accepted: () => state.accepted,
      setAccepted(value) {
        const accepted = Boolean(value);
        state.accepted = accepted;
        writeStored(accepted);
        components.forEach((component) => {
          applyState(component, accepted, { hideError: true });
          clearError(component);
          showStatus(component, '');
          setBusy(component, false);
        });
      },
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
